import * as types from '../ActionTypes/ProfileActionTypes';

export class ProfileActionCreators {
    // get current profile
    static getUserProfileRequest = userId => ({
        type: types.GET_USER_PROFILE_REQUEST,
        meta: { userId },
    });

    static getUserProfileSuccess = payload => ({
        type: types.GET_USER_PROFILE_SUCCESS,
        payload,
    });

    static getUserProfileFailed = payload => ({
        type: types.GET_USER_PROFILE_FAILED,
        payload,
    });

    // get followers
    static getProfileFollowersRequest = userId => ({
        type: types.GET_PROFILE_FOLLOWERS_REQUEST,
        meta: { userId },
    });

    static getProfileFollowersSuccess = payload => ({
        type: types.GET_PROFILE_FOLLOWERS_SUCCESS,
        payload,
    });

    static getProfileFollowersFailed = payload => ({
        type: types.GET_PROFILE_FOLLOWERS_FAILED,
        payload,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/ProfileActionCreators.js